import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit, OnDestroy {
  currentLanguage: 'es' | 'en' = 'es';
  isDarkMode = true;
  private themeObserver?: MutationObserver;

  constructor() { }

  ngOnInit(): void {
    this.detectTheme();
    this.observeThemeChanges();
  }

  ngOnDestroy(): void {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  }

  private detectTheme() {
    this.isDarkMode = document.body.classList.contains('dark-theme');
  }

  private observeThemeChanges() {
    this.themeObserver = new MutationObserver(() => {
      this.detectTheme();
    });
    
    this.themeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  toggleLanguage() {
    this.currentLanguage = this.currentLanguage === 'es' ? 'en' : 'es';
  }

  // Contenido en español
  contentEs = {
    title: 'Política de Privacidad',
    intro: 'Punto de Fuga respeta la privacidad de sus usuarios y se compromete a proteger su información personal.',
    sections: {
      information: {
        title: 'Información recopilada',
        content: 'Punto de Fuga puede recopilar información básica necesaria para operar el servicio, como correo electrónico, datos de cuenta e imágenes cargadas por los usuarios. Las imágenes se procesan únicamente para brindar la funcionalidad solicitada.'
      },
      use: {
        title: 'Uso de la información',
        content: 'La información recopilada se utiliza exclusivamente para operar, mantener y mejorar el servicio. Punto de Fuga no vende ni comparte datos personales con terceros con fines comerciales.'
      },
      content: {
        title: 'Contenido del usuario',
        content: 'Los usuarios conservan la propiedad total de las imágenes que cargan en el servicio. Punto de Fuga no reclama derechos sobre dicho contenido.'
      },
      security: {
        title: 'Seguridad',
        content: 'Se implementan medidas técnicas y organizativas razonables para proteger la información contra accesos no autorizados.'
      },
      thirdParty: {
        title: 'Servicios de terceros',
        content: 'El servicio puede utilizar proveedores de infraestructura de terceros para alojamiento y procesamiento, únicamente con el fin de operar la plataforma.'
      },
      changes: {
        title: 'Cambios a esta política',
        content: 'Esta política puede actualizarse ocasionalmente. El uso continuo del servicio implica la aceptación de los cambios.'
      },
      contact: {
        title: 'Contacto',
        content: 'Para cualquier duda relacionada con privacidad, el usuario puede contactar a Punto de Fuga a través del sitio web oficial.'
      }
    }
  };

  // Contenido en inglés
  contentEn = {
    title: 'Privacy Policy',
    intro: 'Punto de Fuga respects the privacy of its users and is committed to protecting personal information.',
    sections: {
      information: {
        title: 'Information Collected',
        content: 'Punto de Fuga may collect basic information required to provide the service, such as email address, account details, and images uploaded by users. Images are processed only to deliver the requested functionality.'
      },
      use: {
        title: 'Use of Information',
        content: 'Collected information is used solely to operate, maintain, and improve the service. Punto de Fuga does not sell or share personal data with third parties for marketing purposes.'
      },
      content: {
        title: 'Customer Content',
        content: 'Users retain full ownership of any images uploaded to the service. Punto de Fuga does not claim ownership of customer content.'
      },
      security: {
        title: 'Data Storage and Security',
        content: 'Reasonable technical and organizational measures are implemented to protect user data against unauthorized access, loss, or misuse.'
      },
      thirdParty: {
        title: 'Third-Party Services',
        content: 'The service may rely on third-party infrastructure providers for hosting and processing. These providers are used only to deliver the service.'
      },
      changes: {
        title: 'Changes to This Policy',
        content: 'This Privacy Policy may be updated from time to time. Continued use of the service indicates acceptance of the updated policy.'
      },
      contact: {
        title: 'Contact',
        content: 'For privacy-related questions, please contact Punto de Fuga through the official website.'
      }
    }
  };

  get content() {
    return this.currentLanguage === 'es' ? this.contentEs : this.contentEn;
  }
}
